<div class="text-libre-form" [class.block-loader]="loader.isLoading$ | async">
	<loader-spinner [model]="loader" *ngIf="loader"></loader-spinner>
	<form [formGroup]="form">
		<div class="row">
			<div class="col-8">
				<div class="form-group">
					<label for="field-commentaire" class="form-label form-label-required" translate="Labels.Commentaire"> </label>
					<textarea
						[placeholder]="'Forms.Placeholder.Comment' | translate"
						class="form-label"
						id="field-commentaire"
						formControlName="commentaire"
						[class.is-invalid]="commentaireField.dirty && commentaireField.invalid"
						maxLength="255"
					></textarea>
					<form-control-feedback [field]="commentaireField"></form-control-feedback>
				</div>
			</div>
			<div class="col-4 bottom-right-buttons">
				<button *ngIf="operation" type="button" class="btn btn-secondary" (click)="handleOpenUploadDocumentsModal($event)">
					<i class="far fa-paperclip"></i>
				</button>
				<button type="button" class="btn btn-primary" (click)="onSubmit()">
					<i class="far fa-paper-plane"></i>
				</button>
			</div>
		</div>
		<div class="chips-extended-items" *ngFor="let item of documentsField?.value?.filesList; let i = index">
			<div class="chips-extended-items-actions">
				<span class="text">
					{{ item?.file?.name }}
				</span>

				<button class="button" (click)="deleteFile(i)">&times;</button>
			</div>
		</div>
	</form>
	<p class="form-required-fields" translate="Forms.RequiredFields"></p>
</div>
